import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/renewals/license.renewals.query.gql"
import type {
  RenewalTimelineQuery,
  RenewalTimelineQueryVariables,
} from "@/v2-backoffice-client/license/renewals/__types__/license.renewals.query"

export function useRenewalTimelineQuery(
  options?: QueryHookOptions<
    RenewalTimelineQuery,
    RenewalTimelineQueryVariables
  >,
) {
  return useQuery<RenewalTimelineQuery, RenewalTimelineQueryVariables>(
    query,
    options,
  )
}
